import FinancialView from '@/views/financial/FinancialView.vue';

import commissionManager from '@/views/financial/commissionManager';
import indicatedManager from '@/views/financial/indicatedManager';

import filterStorageMixin from '@/mixins/filterStorage.mixin';
import loadingMixin from '@/mixins/loadingView.mixin';

const name = 'promoters';
const path = '/promotores';

const commonMixins = [
  filterStorageMixin,
  loadingMixin,
];

const commissionComponentConfig = {
  component: {
    ...FinancialView,
    mixins: [
      ...commonMixins,
      commissionManager,
    ],
  },
};

const indicatedComponentConfig = {
  component: {
    ...FinancialView,
    mixins: [
      ...commonMixins,
      indicatedManager,
    ],
  },
};

export default [
  // routes
  {
    name: `${name}-commission`,
    path: `${path}/comissoes`,
    ...commissionComponentConfig,
  },
  {
    name: `${name}-commission-details`,
    path: `${path}/comissoes/:id`,
    ...commissionComponentConfig,
    props: true,
  },
  {
    name: `${name}-commission-indicated`,
    path: `${path}/comissoes/indicadas`,
    ...indicatedComponentConfig,
  },
  {
    name: `${name}-commission-indicated-details`,
    path: `${path}/comissoes/indicadas/:id`,
    ...indicatedComponentConfig,
    props: true,
  },
  {
    name: `${name}-goals`,
    path: `${path}/metas`,
    component: () => import('@/views/Goals.vue'),
    props: true,
  },
  {
    name: `${name}-goals-edit`,
    path: `${path}/metas/:id`,
    component: () => import('@/views/Goals.vue'),
    props: true,
  },
  {
    name: `${name}-bonds`,
    path: `${path}/indicadas`,
    component: () => import('@/views/PromotersBonds.vue'),
    props: true,
    beforeEnter: (to, from, next) => {
      if (to.params.promoterId && to.params.promoterName) next();
      else next({ name });
    },
  },
  {
    name,
    path,
    component: () => import('@/views/PromotersList.vue'),
    props: true,
  },
  {
    name: `${name}-edit`,
    path: `${path}/:id`,
    component: () => import('@/views/PromotersEdit.vue'),
    props: true,
  },
  {
    name: 'do-not-disturb',
    path: '/nao-perturbe',
    component: () => import('@/views/DoNotDisturbConsult.vue'),
    props: true,
  },

  // redirects (legacy)
  {
    path: '/usuarios/promotores/:id',
    redirect: `${path}/:id`,
  },
  {
    path: '/comissoes',
    redirect: `${path}/comissoes`,
  },
  {
    path: '/comissoes/:id',
    redirect: `${path}/comissoes/:id`,
  },
  {
    path: '/metas',
    redirect: `${path}/metas`,
  },
  {
    path: '/metas/:id',
    redirect: `${path}/metas/:id`,
  },
];
